import { Component, OnInit,  OnChanges, Output, EventEmitter } from '@angular/core';
import { PropertyService } from '../shared/property.service';
import {MatSidenavModule} from '@angular/material';

@Component({
  selector: 'sold-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {

  phonePopup: boolean = false;
  deviceWidth: any;
  potNumber: number;

  @Output() openNav = new EventEmitter();

  constructor(public _propertyService: PropertyService) {
    this.deviceWidth = (window.screen.width);
   }

  openSideNav() {
    this.openNav.emit();
  }

  showPhonePopup() {
    if (this.deviceWidth > 767) {
      this.phonePopup = true;
    }
  }

  hidePhonePopup() {
    this.phonePopup = false;
  }

  newsLink() {
    window.open(
      'https://valuation.haart.co.uk/local/',
      '_blank'
    );
  }

  findSimmilarPropertiesLnk() {
    var highestPrice = this._propertyService.propPrice * 1.1;
    var lowestPrice = this._propertyService.propPrice * 0.9;

    window.open(
     this. _propertyService.baseSite + 'search/?IsPurchase=true&Location=' + this._propertyService.location + '&SearchDistance=2&Latitude=' + this._propertyService.propertyLongLat.Lat + '&Longitude=' + this._propertyService.propertyLongLat.Long + '&MinPrice=' + lowestPrice + '&MaxPrice=' + highestPrice + '&MinimumBeds=&SortBy=&Page=1&NumberOfResults=0&Stc=True&' + this._propertyService.propLinkReferer + "/FindSimilar"
    )
  }

  moreInfoLnk() {
    window.open(
      this. _propertyService.baseSite + this._propertyService.propRef + "?" + this._propertyService.propLinkReferer + "/MoreInfo"
     )
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/footer/footer.component.ts